import React, { Component } from "react";
import ReportTableHeader from "./../ReportTableHeader";
import ReportTablePivot from "./../ReportTablePivot";
import ReportTableDashboard from "../ReportTableDashboard";
import { Scrollbars } from "react-custom-scrollbars-2";
import styles from "./../reportTable.module.scss";
import ReportTableUnitInfo from "../ReportTableUnitInfo";

const rowStyles = [styles.reportTableRow, styles.reportTableRowBackground];

class ReportTableByDay extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { scrollbar } = this.refs;

    scrollbar.scrollTop(this.props.scroll);
  }

  componentWillUnmount() {
    const { scrollbar } = this.refs;
    const { unitId } = this.props;
    this.props.onSetSctollUnitReport(unitId, scrollbar.getScrollTop());
  }

  getRowCell(item, key) {
    return (
      <div key={key} className={styles.reportTableRowItem} style={{ width: item.width + "px", border: "none" }}>
        <span style={{ border: "none" }}>{item.value}</span>
      </div>
    );
  }

  getRows(days) {
    let rowStyle = rowStyles[1];

    return days.map((day, index) => {
      rowStyle = rowStyle === rowStyles[0] ? rowStyles[1] : rowStyles[0];

      return (
        <div className={styles.reportTableRowCursor} key={day.day + index}>
          <div className={rowStyle} key={index}>
            {day.rows[0].data.map((item, column) => {
              return this.getRowCell(item, index + column);
            })}
          </div>
        </div>
      );
    });
  }

  render() {
    const { data, height = 450 } = this.props;

    return (
      <div className={styles.reportTableContainer}>
        <ReportTableUnitInfo info={data.info} />
        <ReportTableDashboard dashboards={data.dashboard} prefixKey={"main"} />
        <Scrollbars style={{ height: height + "px" }} autoHide={false} ref="scrollbar">
          <ReportTableHeader header={data.header} withScroll={false} />

          {this.getRows(data.days)}
          <ReportTablePivot pivot={data.pivot} />
        </Scrollbars>
      </div>
    );
  }
}

export default ReportTableByDay;
